export function isSafariUserAgent(userAgent: string): boolean {
    return /Safari/i.test(userAgent)
        && !/(Chrome|Chromium|CriOS|FxiOS|Edg|EdgiOS|OPR|OPiOS|Android)/i.test(userAgent);
}

export function isAppleMobileUserAgent(userAgent: string): boolean {
    return /(iPhone|iPad|iPod)/i.test(userAgent)
        || (/Macintosh/i.test(userAgent) && /Mobile/i.test(userAgent));
}

export function isAndroidUserAgent(userAgent: string): boolean {
    return /Android/i.test(userAgent);
}

export function isMobileSafariUserAgent(userAgent: string): boolean {
    return isAppleMobileUserAgent(userAgent) && isSafariUserAgent(userAgent);
}
